// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ResourceCardSmall_wrapper"};